// extracted by mini-css-extract-plugin
export default {"wrapper":"tDZTa8dy9OMVyGAtxNOS","valueBox":"VoBl8JcsRZelj8EKGKtC"};